var _path, _g, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQrScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 35,
    fill: "none",
    viewBox: "0 0 41 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2.19,
    d: "M9.75 11.88v-4c0-.79.64-1.44 1.44-1.44h3.99m10.86 0h4c.8 0 1.44.65 1.44 1.45v3.99m-16.3 16.3H11.2c-.8 0-1.44-.65-1.44-1.45v-3.98m21.72 0v3.99c0 .8-.65 1.44-1.45 1.44h-3.98"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Frame_616_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.44 8.77c.42.04.92-.05 1.43.06a2.83 2.83 0 0 1 2.25 2.8c0 .74.07 1.5-.03 2.23a2.75 2.75 0 0 1-2.66 2.48c-.8.05-1.6.08-2.4-.03a2.78 2.78 0 0 1-2.47-2.67 13.6 13.6 0 0 1 .04-2.47 2.83 2.83 0 0 1 2.7-2.4h1.14Zm-.1 1.9h-.95c-.55.02-.93.4-.94.94v1.88c0 .54.39.94.93.95.65.02 1.3.02 1.94 0a.9.9 0 0 0 .9-.9c.02-.65.02-1.3 0-1.95 0-.54-.38-.9-.92-.92h-.95ZM12.1 21.93c.03-.47-.06-1.02.08-1.56a2.8 2.8 0 0 1 2.56-2.13c.8-.07 1.63-.09 2.44.03a2.75 2.75 0 0 1 2.48 2.65c.06.78.09 1.58-.02 2.37-.2 1.37-1.04 2.28-2.4 2.46-.95.13-1.92.15-2.86-.02a2.77 2.77 0 0 1-2.28-2.8v-1Zm3.79 1.97h.99a.9.9 0 0 0 .9-.92v-1.9c-.02-.55-.4-.94-.95-.95h-1.9a.9.9 0 0 0-.93.92v1.94a.9.9 0 0 0 .9.9c.33.02.66 0 .99 0Zm7.56-4.7a.95.95 0 1 1-1.9-.04.95.95 0 0 1 1.9.03Zm0 1.85a.95.95 0 1 1 1.9.04.95.95 0 0 1-1.9-.04Zm.94 4.75a.95.95 0 1 1 .02-1.9.95.95 0 0 1-.02 1.9Zm4.74-4.73c0 .51-.42.94-.94.95a.96.96 0 0 1-.96-.93.95.95 0 1 1 1.9-.02Zm-.96 4.73a.96.96 0 0 1-.94-.95c0-.52.45-.96.98-.95.5.02.93.46.92.97a.95.95 0 0 1-.96.93Zm-.94-6.62c0 .53-.42.94-.94.94a.93.93 0 0 1-.94-.96.94.94 0 0 1 1.88.02Zm-.93 2.84c.53 0 .93.41.93.95 0 .52-.41.93-.94.93a.92.92 0 0 1-.94-.96c0-.53.42-.92.95-.92Zm-3.8 1.88a.94.94 0 1 1 0-1.88c.53 0 .96.42.95.96 0 .52-.43.92-.95.92Zm-6.61-13.23h.98c.52.03.9.4.9.92v1.94c-.01.5-.4.9-.9.91-.66.02-1.32.02-1.98 0a.9.9 0 0 1-.89-.88c-.01-.67-.01-1.34 0-2.01.02-.5.39-.85.9-.87.33-.02.66 0 .99 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.35 10.67h.99c.51.03.89.4.9.92v1.94c-.01.5-.4.9-.9.91-.66.02-1.33.02-1.98 0a.9.9 0 0 1-.9-.88v-2.01c.02-.5.4-.85.9-.87.33-.02.66 0 1 0ZM15.89 23.9h-1A.89.89 0 0 1 14 23a45.3 45.3 0 0 1 0-1.95.9.9 0 0 1 .92-.92h1.91c.54.01.93.4.94.94v1.91a.9.9 0 0 1-.9.92h-.98Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.45,
    d: "M10.47 21.07h20.06M7.14 19.62h26.72"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Frame_616_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h17.05v17.08H0z",
    transform: "translate(12.1 8.77)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScan);
export default __webpack_public_path__ + "static/media/qr-scan.fb6ded61.svg";
export { ForwardRef as ReactComponent };